///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { closeUserDialog, deleteSale, getSuccessorCompaniesList, setSuccessorCompaniesList } from '../../store/users-list.actions';
import { AbstractDialogComponent } from '../../../dialog-manager/abstract-dialog.component';
import { Actions, ofType } from '@ngrx/effects';
import { SuiTypeSelect } from '@siklu/sui-lib/infrastructure';
import {
    GtthKeyValueDTO,
    SaleWithCompaniesCountProjection,
    SuccessorSaleCompaniesToAddProjection
} from '../../../generated/shared-types.model';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { Observable, tap } from 'rxjs';
import { LoaderIds, PreloaderService } from '../../../services/preloader.service';

@Component({
    selector: 'winde-sale-delete-dialog',
    templateUrl: './sale-delete-dialog.component.html',
    styleUrls: ['./sale-delete-dialog.component.scss'],
    standalone: false
})
export class SaleDeleteDialogComponent extends AbstractDialogComponent {
    public saleDeleteDialogKey: LoaderIds = LoaderIds.SALE_DELETE_DIALOG;
    public saleUser: SaleWithCompaniesCountProjection = this.data.payload;
    public hasSaleCompanies = this.saleUser.saleCompaniesCount > 0;
    public saleSelectList: SuiTypeSelect<GtthKeyValueDTO>;
    public successorCompaniesList$: Observable<GtthKeyValueDTO[]> = this.actions$.pipe(
        ofType(setSuccessorCompaniesList),
        map((action) => action.successorCompaniesList),
        map((successorCompaniesList: SuccessorSaleCompaniesToAddProjection[]) =>
            successorCompaniesList.map(
                (company: SuccessorSaleCompaniesToAddProjection): GtthKeyValueDTO => ({
                    key: company.saleId,
                    value: `${company.login} - ${company.companiesCount} companies`
                })
            )
        ),
        tap((successorCompaniesList: GtthKeyValueDTO[]): void => {
            this.saleSelectList = new SuiTypeSelect<GtthKeyValueDTO>(successorCompaniesList[0], successorCompaniesList, 'value');
        })
    );

    constructor(
        public readonly preloaderService: PreloaderService,
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly dialogRef: MatDialogRef<SaleDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { payload: SaleWithCompaniesCountProjection }
    ) {
        super();
        this.actions$.pipe(ofType(closeUserDialog)).subscribe(() => {
            this.dialogRef.close();
        });

        if (this.hasSaleCompanies) {
            this.store.dispatch(getSuccessorCompaniesList({ saleId: this.saleUser.saleId }));
        }
    }

    public confirmDelete(): void {
        this.store.dispatch(deleteSale({ id: this.saleUser.saleId, reassignSaleId: this.saleSelectList?.value?.key }));
    }
}
